module.exports = "/packs/media/images/avatar-nick-4d9b18ed4666199078157d42235ee7b1.jpg";